module.exports = __webpack_public_path__ + "static/media/icon-xls.bdd70c65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-xls.svg
// module id = 528
// module chunks = 0